var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { TrackingElement } from '@sumup/collector';
import styled from '../../styles/styled';
import { focusVisible } from '../../styles/style-mixins';
import Hamburger from '../Hamburger';
import { SkeletonContainer } from '../Skeleton';
import { ProfileMenu } from './components/ProfileMenu';
import { UtilityLinks } from './components/UtilityLinks';
import { TRACKING_ELEMENTS } from './constants';
const CONTENT_HEIGHT = '56px';
export const TOP_NAVIGATION_HEIGHT = '57px'; /* content height + border-bottom */
const headerStyles = ({ theme }) => css `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${TOP_NAVIGATION_HEIGHT};
  background-color: var(--cui-bg-normal);
  border-bottom: ${theme.borderWidth.kilo} solid var(--cui-border-divider);

  ${theme.mq.tera} {
    position: sticky;
    top: 0;
    /* The +1 is necessary to ensure that the primary navigation doesn't */
    /* overlap the top navigation on hover. */
    z-index: ${theme.zIndex.navigation + 1};
  }
`;
const Header = styled.header(headerStyles);
const hamburgerStyles = (theme) => css `
  padding: ${theme.spacings.mega};
  ${focusVisible('inset')()};

  border-radius: 0;
  /* The !important below is necessary to override the default hover styles. */
  border-right: ${theme.borderWidth.kilo} solid var(--cui-border-divider) !important;

  ${theme.mq.tera} {
    display: none;
  }
`;
const logoStyles = ({ theme }) => css `
  height: ${CONTENT_HEIGHT};

  > * {
    display: block;
    height: inherit;
    line-height: 0;
    padding: ${theme.spacings.mega};
  }

  a,
  button {
    ${focusVisible('inset')()};
  }

  svg {
    color: var(--cui-fg-normal);
    height: ${theme.iconSizes.mega};
  }
`;
const Logo = styled.div(logoStyles);
const wrapperStyles = css `
  display: flex;
  align-items: stretch;
  height: 100%;
`;
export function TopNavigation(_a) {
    var { logo, user, profileMenu, links, hamburger, isLoading } = _a, props = __rest(_a, ["logo", "user", "profileMenu", "links", "hamburger", "isLoading"]);
    return (_jsx(TrackingElement, Object.assign({ name: TRACKING_ELEMENTS.TOP_NAVIGATION }, { children: _jsxs(Header, Object.assign({ role: "banner" }, props, { children: [_jsxs("div", Object.assign({ css: wrapperStyles }, { children: [hamburger && (_jsx(SkeletonContainer, Object.assign({ isLoading: Boolean(isLoading) }, { children: _jsx(Hamburger, Object.assign({}, hamburger, { css: hamburgerStyles })) }))), _jsx(Logo, { children: logo })] })), _jsxs(SkeletonContainer, Object.assign({ css: wrapperStyles, isLoading: Boolean(isLoading) }, { children: [links && _jsx(UtilityLinks, { links: links }), _jsx(ProfileMenu, Object.assign({}, profileMenu, { user: user }))] }))] })) })));
}
